<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_purchase_order_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="采购单号">
							<c-input name="purchase_code"></c-input>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="purchase_states" :options="purchaseStateDic" multiple></c-select>
						</m-search-item>
                        <m-search-item label="供应商">
                            <c-select name="supplier_ids" async multiple @search="searchSupplier" ></c-select>
                        </m-search-item>
                        <m-search-item label="采购员">
                            <c-select name="purchase_user_ids" async multiple @search="searchUser" ></c-select>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info" placeholder="支持产品编号/名称/规格"></c-input>
                        </m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="完成时间" colspan="2">
							<c-datetime range start-name="finish_start_date" end-name="finish_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_purchase_order_create')" v-lock="lock('b_purchase_order_create')" prepend-icon="tf-add" @click="editOrder()">创建采购单</c-button>
					<c-button v-if="auth('b_purchase_order_export')" v-lock="lock('b_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_purchase_order_export')" v-lock="lock('b_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
                    <c-button v-if="auth('b_purchase_order_edit') || auth('b_purchase_order_create')" v-lock="lock('b_purchase_order_create')" prepend-icon="tf-import" @click="importData()">导入</c-button>
                </template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_purchase_order_export')" v-lock="lock('b_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_purchase_order_export')" v-lock="lock('b_purchase_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_purchase_order_print')" v-lock="lock('b_purchase_order_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_purchase_order_log')" v-lock="lock('b_purchase_order_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_purchase_order_log')" v-lock="lock('b_purchase_order_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #purchase_code="{data}">
					<c-link @click="globalDialog('purchaseOrderDetail', {props: {id: data.id}})">{{data.purchase_code}}</c-link>
				</template>

				<!--状态-->
				<template #purchase_state="{data}">
					<c-state dict="purchaseStateDic" tag :value="data.purchase_state"></c-state>
				</template>

                <!--采购金额-->
                <template #purchase_money="{data}">
                    <span v-if="data.purchase_money">￥{{data.purchase_money}}</span>
                    <span v-else>-</span>
                </template>
				<!--采购金额 -合计行-->
				<template #purchase_money_summed="{total}">
					￥{{total}}
				</template>

				<!--逾期状态-->
				<template #plan_date_state="{data}">
					<c-state type="expectedDate" :value="data.expected_date"></c-state>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_purchase_order_edit')" v-lock="lock('b_purchase_order_edit')" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
                        <c-table-button icon="tf-detail" @click="globalDialog('purchaseOrderDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_print')" v-lock="lock('b_purchase_order_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_storage')" v-lock="lock('b_purchase_order_storage')" icon="tf-take-goods" :disabled="data.purchase_state != 2" @click="storageOrder(data.id)">收货</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_return')" v-lock="lock('b_purchase_order_return')" icon="tf-return-goods" :disabled="data.purchase_state != 2" @click="returnOrder(data.id)">退货</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_edit')" v-lock="lock('b_purchase_order_edit')" :disabled="!(data.purchase_state != 2)" icon="tf-start" @click="editState(data, 2)">开始</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_edit')" v-lock="lock('b_purchase_order_edit')" :disabled="!(data.purchase_state == 2)" icon="tf-finish" @click="editState(data, 3)">完成</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_edit')" v-lock="lock('b_purchase_order_edit')" :disabled="!(data.purchase_state != 4)" icon="tf-cancel" @click="editState(data, 4)">取消</c-table-button>
						<c-table-button v-if="auth('b_purchase_order_delete')" v-lock="lock('b_purchase_order_delete')" icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>

            <!--采购单入库操作弹窗-->
			<purchase-storage-edit ref="purchaseStorageEdit" @resolve="$refs.view.update()" ></purchase-storage-edit>
            <!--采购单退货出库操作弹窗-->
			<purchase-return-edit ref="purchaseReturnEdit" @resolve="$refs.view.update()" ></purchase-return-edit>
		</module>
	</page>
</template>

<script>
	import purchaseStorageEdit from '@/pages/purchase/purchase_storage_edit.vue'
	import purchaseReturnEdit from '@/pages/purchase/purchase_return_edit.vue'
	import {mapState} from 'vuex'

	export default {
		components: {
            purchaseStorageEdit,
			purchaseReturnEdit
		},
		
		data() {
			return {
                workType:39,            //采购单业务
                view_id:10015           //采购单_产品明细_辅视图
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['purchaseStateDic'])
		},
		
		methods: {
            /*******搜索【供应商】下拉框信息*****************/
            searchSupplier(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SUPPLIER',
                        keyword: keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

            /*******搜索用户*****************/
            searchUser(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code:'SYSUSER',
                        keyword: keyword
                    },
                    success:data => {
                        resolve(data);
                    }
                })
            },

			/******新建/编辑订单*******/
			editOrder(data = {}) {
				this.globalDialog('purchaseOrderEdit', {data}, this.$refs.view.update);
			},

			/******订单收货*******/
            storageOrder(purchase_order_id) {
				this.$refs.purchaseStorageEdit.open(purchase_order_id);
			},

			/******订单退货*******/
            returnOrder(purchase_order_id) {
				this.$refs.purchaseReturnEdit.open(purchase_order_id);
			},
			
			/******修改状态************/
			editState(data, purchase_state){
				this.request({
					url: '/purchase/order/editState',
					data: {
						id: data.id, 
						purchase_state: purchase_state,
					},
					loading: true,
					success: data => {
						var mess = '';
						if(purchase_state == 2){
							mess = '修改为[执行中]状态成功';
						}else if(purchase_state == 3){
							mess = '修改为[已完成]状态成功';
						}else if(purchase_state == 4){
							mess = '修改为[取消]状态成功';
						}
						
						this.$message({
							message: mess,  // 提示内容,
							type: 'success'
						});
						//刷新
						this.$refs.view.update();
					}
				});
			},

			/******删除订单************/
			removeOrder(data){
                var message = '是否确认删除采购单【'+data.purchase_code+'】？删除后不可恢复，请谨慎操作；<span style="color:red">（删除后，关联的入库单、出库单也将一起删除，相关商品库存将会回滚）</span>';
				this.$confirm({
					message:message,  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/purchase/order/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

            /*******导入数据************/
            importData() {
                this.$refs.view.excelImport(Object.assign({}, {
                    view_id: this.view_id
                }));
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>